import React from "react";
var __jsx = React.createElement;
var TrackingEmptyState = function TrackingEmptyState(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    buttonText = _ref.buttonText,
    image = _ref.image,
    onButtonClick = _ref.onButtonClick;
  return /*#__PURE__*/React.createElement("div", {
    className: "bg-white rounded-2xl drop-shadow-[0px_1px_1px_rgba(0,0,0,0.08)] flex flex-col items-center justify-center gap-6 p-4 lg:p-10 w-full"
  }, /*#__PURE__*/React.createElement("img", {
    src: image,
    alt: "Empty state illustration",
    className: "w-[93px] h-[74px] lg:w-[230px] lg:h-[183px]"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center gap-8 lg:gap-16 w-full max-w-[440px]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center gap-3 lg:gap-3.5 text-center text-[#00143c]"
  }, /*#__PURE__*/React.createElement("p", {
    className: "font-bold text-lg lg:text-2xl leading-7 lg:leading-8"
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "font-normal text-sm lg:text-base leading-5 lg:leading-6"
  }, subtitle)), buttonText && onButtonClick && /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onButtonClick,
    className: "border-none w-full flex items-center justify-center bg-[#0d0db5] text-white rounded px-4 py-3 text-base font-bold leading-6"
  }, buttonText)));
};
export default TrackingEmptyState;